import React from 'react';

export const Expenses: React.FC = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Expenses</h1>
    </div>
  );
};
